var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessRaceIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2002 21V4H13.7752L14.2502 6.15H20.2002V15.4H13.8002L13.3252 13.275H6.7002V21H5.2002ZM15.0752 13.9H18.7002V7.65H12.9752L12.5002 5.5H6.7002V11.775H14.6002L15.0752 13.9Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessRaceIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Success_Race_icon.eb650b86d93d91277b85af75c95988b6.svg";